import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-blue-background b-blue-background__opacity b-blue-background--fixed" }
const _hoisted_2 = { class: "h-flex-dir-column h-flex-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "h-font-22 h-mt-20 h-mb-0" }
const _hoisted_5 = { class: "h-mt-10 h-text-center h-mb-20 h-width-250" }
const _hoisted_6 = {
  class: "h-flex h-flex-center",
  style: {"height":"20%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwPopup = _resolveComponent("FwPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwPopup, {
      centered: true,
      isFixed: true,
      iconColor: "#BEC7D4",
      "max-width": "800px",
      width: "auto",
      title: "",
      allowBackgroundScrolling: true,
      showClosePopup: false,
      popupBackground: "#F8F9FA",
      popupRadius: "20px",
      heightValue: "100%",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit("close")))
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "h-ph-50",
            src: _ctx.requireImage("private-image.svg")
          }, null, 8, _hoisted_3),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('EVENT.PRIVATE.TITLE')), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('EVENT.PRIVATE.TEXT')), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_FwButton, {
            class: "h-mt-20",
            borderRadiusType: "small-border",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("close")))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('POPUP.FINALY.CLOSE')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}